"use strict"
import { getRequest, postRequest } from "@/services/RequestService";

export const getAdvert = async (status) => {
  const base_route = `promotions/advert/get/${status == 1 ? 'active' : 'inactive'}`;
  const response = await getRequest(base_route);
  return response;
}

export const storeAdvert = async (request) => {
  const base_route = `promotions/advert`;
  const response = await postRequest(base_route, request);
  return response;
}

export const editAdvert = async (request) => {
  const base_route = `promotions/advert/update`;
  const response = await postRequest(base_route, request);
  return response;
}

export const viewAdvert = async (advert_id) => {
  const base_route = `promotions/advert/show/${advert_id}`;
  const response = await getRequest(base_route);
  return response;
}

export const toogleActiveStatus = async (request) => {
  const base_route = `promotions/advert/toggle-status`;
  const response = await postRequest(base_route, request);
  return response;
}

export const viewLogs = async (advert_id) => {
  const base_route = `promotions/advert/logs?promotion=${advert_id}`;
  const response = await getRequest(base_route);
  return response;
}
